import type { Customer } from '@vy/types';
import { isNotNullOrUndefined } from '@vy/utils';

export function getCustomerInfoFields(customer: Customer) {
  const infoFields = [];
  const firstContact = customer.contacts?.[0];
  const customerCountry = customer.address?.country;

  if (isNotNullOrUndefined(firstContact)) {
    infoFields.push({ label: 'Email', value: <span>{firstContact.email}</span> });
  }

  if (isNotNullOrUndefined(customerCountry)) {
    infoFields.push({ label: 'Country', value: <span>{customerCountry}</span> });
  }

  return infoFields;
}
